













    import Vue from 'Vue';
    import { IInteractiveSnackbar } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name:'interactive-snackbar',
        data(): any {
            return { timeout:-1 }
        },
        computed: {
            show: {
                get(): boolean {
                    return this.$store.state.ui.interactiveSnackBar.show;
                },
                set(newVal: boolean) {
                    this.$store.commit('ui/interactiveSnackBar/setShow', newVal);
                }
            },
            message(): string {
                return this.$store.state.ui.interactiveSnackBar.message;
            },
            btnText(): string { return this.$store.state.ui.interactiveSnackBar.buttonText; },
            showActivity(): boolean { return this.$store.state.ui.interactiveSnackBar.showActivity; }
        },
        created (): void {
        },
        methods: {
            closeClicked() {
                this.show = false;
                if (this.$store.state.ui.interactiveSnackBar.callback)
                    this.$store.state.ui.interactiveSnackBar.callback();
            }
        }
    });
